import axios from "axios";

export function uploadSourceFile(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/resource`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function deleteSelectedFile(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/file/multidelete`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function getUsers(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/users/pagination` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function deleteUser(id) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .delete(`${process.env.REACT_APP_API_URL}v1/users/` + id, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export async function postAdduser(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .post(`${process.env.REACT_APP_API_URL}v1/users`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function getUser(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(`${process.env.REACT_APP_API_URL}v1/users/` + qString, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function postEdituser(qString, id) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}v1/users/` + id,
      qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function dataSourceList(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/resource/pagination/` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function publicFileLink(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/resource/url`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function rolesList(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };
  return axios
    .get(`${process.env.REACT_APP_API_URL}v1/roles` + qString, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function getEventLog(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/event-logs/pagination` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function uploadProductFile(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/products`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function generateBOQ(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/boq`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function uploadBOQ(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/boq-upload`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function publicExportedFileLink(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/event-logs/url`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export async function downloadTemplateFile() {
  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}v1/resource/download`,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
    responseType: "arraybuffer",
  };

  return axios
    .request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function dataProductList(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/products/` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export async function getJobWithProducts(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };
  return await axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/products/jobs` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function getAllProducts(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/products/export` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function deleteJobs(data) {
  let config = {
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}v1/products/job`,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
    data: data,
  };

  return axios
    .request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function insertExcel(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/resource/insert-excel`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function groundingProduct(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/products/grounding`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function getGroundingList(qString, data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/products/groundinglist` + qString,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function updateGrounding(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/products/grounding-confirm`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function searchGroundingList(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/products/groundinglist/search` +
        qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function deleteSourceFile(data) {
  let config = {
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}v1/resource`,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
    data: data,
  };

  return axios
    .request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
export function deleteSourceData(data) {
  let config = {
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}v1/resource/data`,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
    data: data,
  };

  return axios
    .request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function importProduct(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/products/import`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function getTorForms() {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .get(`${process.env.REACT_APP_API_URL}v1/boq/tor`, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function checkTorFormsExist(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/boq/tor-exist`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function getFileOwner(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return await axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/resource/file-owner` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function downloadTORFile(data) {
  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API_URL}v1/boq/tor-download`,
    data: data,
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
    responseType: "arraybuffer",
  };

  return await axios
    .request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
